import Validations from 'vuelidate'
import VueRellax from 'vue-rellax'
// import VuePageTransition from 'vue-page-transition'
// const VuePageTransition = require('vue-page-transition')
// import Calendar from 'v-calendar'
// const Calendar = require('v-calendar')
import VuePlyr from 'vue-plyr'

import entry from './index'
import store from './../store/main'
import defineRouter from './../router/main'

const router = defineRouter(store)

entry(router, store, 'main', {
  plugins: [
    Validations,
    VueRellax,
    // Calendar,
    VuePlyr,
  ],
})
